import { AuthService } from 'src/app/_services/auth.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import liff from '@line/liff';
import { Observable } from 'rxjs';

@Injectable()
export class LineParentGuard implements CanActivate {
    states = {
        name: '',
        userLineID: '',
        pictureUrl: ''
    };
    constructor(private router: Router, private _authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        return new Promise(async (resolve, reject) => {
            await liff.init({ liffId: "1657381723-AmnDOEWk" }) //สารวิทยา

            // alert('1');

            if (liff.isInClient()) {
                let profile = await liff.getProfile()
                this.states.name = profile.displayName
                this.states.userLineID = profile.userId
                this.states.pictureUrl = profile.pictureUrl

                await this._authService.doLineParent(profile.userId).then(resp => {

                    if (resp.user) {
                        localStorage.setItem('currentUser', JSON.stringify(resp.user));
                    } else {
                        localStorage.setItem('currentUser', JSON.stringify(resp));
                    }
                    localStorage.setItem('token', resp.token);
                    resolve(true);
                }).catch(err => {
                    this.router.navigate(['/parent/auth'], { queryParams: { returnUrl: state.url } });
                    resolve(false);
                })
                // alert('2');

            } else {
                // alert('3');
                if (!liff.isLoggedIn()) {
                    liff.login();
                }
                this.router.navigate(['/parent/auth'], { queryParams: { returnUrl: state.url } });
                resolve(false);
            }


        });
    }
}
